import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.form`
  text-align: left;
`);



// WEBPACK FOOTER //
// ./src/components/blocks/Form.js